export type Name = {
    full?: string | null | undefined;
    short?: string | null | undefined;
};

export type NamedNode = { name?: Name | null | undefined };

export type NameInput = string | Name | NamedNode | null | undefined;

export function isNamedNode(
    value: unknown
): value is NamedNode & { name: Name | null | undefined } {
    return (
        typeof value === 'object' &&
        value !== null &&
        'name' in value &&
        isName(value.name)
    );
}

export function isStringOrNothing(
    value: unknown
): value is string | null | undefined {
    return typeof value === 'string' || value === undefined || value === null;
}

export function isName(value: unknown): value is Name {
    return (
        typeof value === 'object' &&
        value !== null &&
        (('full' in value && isStringOrNothing(value['full'])) ||
            ('short' in value && isStringOrNothing(value['short'])))
    );
}

export function isNameInput(value: unknown): value is NameInput {
    return (
        value !== null &&
        value !== undefined &&
        (isStringOrNothing(value) || isName(value) || isNamedNode(value))
    );
}

export function getName(input: unknown): Name | null {
    if (typeof input === 'string') return { full: input, short: input };
    if (isNamedNode(input)) return input.name ?? null;
    if (isName(input)) return input;
    return null;
}

export function getFullName(input: unknown): string | null {
    if (typeof input === 'string') return input;
    if (isNamedNode(input)) input = input.name;
    if (isName(input)) return input.full ?? input.short ?? null;
    return null;
}

export function getShortName(input: unknown): string | null {
    if (typeof input === 'string') return input;
    if (isNamedNode(input)) input = input.name;
    if (isName(input)) return input.short ?? input.full ?? null;
    return null;
}
